import { useState } from 'react'
import { useMount } from 'ahooks'
import { useAliveController } from 'react-activation'
import { t } from '@/utils/i18n'
import { CheckList, NavBar } from 'antd-mobile'
import { LeftOutline } from 'antd-mobile-icons'
import i18n from '@/utils/i18n'
import {
  getI18nLang,
  getSystemLang,
  langOptions,
  LangOption,
} from '@/utils/i18n'
import { useNavigate } from 'react-router-dom'
import { storageUtil, common } from '@/utils'
import { useCorpSettingStore } from '@/stores'

const { getLocalStorage, setLocalStorage } = storageUtil

const { getCorpSetting } = common

function LangSetting() {
  const navigate = useNavigate()
  const { corpSetting, setCorpSetting } = useCorpSettingStore()
  const { clear: clearKeepAlive } = useAliveController()
  const [langOpt, setLangOpt] = useState<LangOption>({
    text: '中文',
    key: 'zh-CN',
  })

  useMount(() => {
    initLang()
  })

  // // 初始化语言选择，有存储就读存储，否则系统默认
  function initLang() {
    const language = getLocalStorage('language') || getSystemLang()
    const langOptItem = langOptions.find((item) => item.key === language) || {
      text: 'English',
      key: 'en-US',
    }
    setLangOpt(langOptItem)
    const i18nLang = getI18nLang()
    i18n.changeLanguage(i18nLang)
  }

  // 选择语言
  async function onSelectLang(value: string[]) {
    const key = value[0]
    const langOpt = langOptions.find((item) => item.key === key)
    if (!langOpt) return

    i18n.changeLanguage(key)
    setLangOpt(langOpt)
    corpSetting.language = key
    setCorpSetting(corpSetting)
    setLocalStorage('language', key)
    clearKeepAlive()

    // 通知app切换语言
    if (
      window.webview?.switchLanguage &&
      typeof window.webview?.switchLanguage === 'function'
    ) {
      window.webview.switchLanguage(String(key)?.replace('-', '_') || '')
    }

    // 获取企业设置，更新企业地址
    await getCorpSetting()
    navigate(-1)
  }

  async function onGoBack() {
    navigate(-1)
  }

  return (
    <div>
      <NavBar
        children={t('多语言')}
        backArrow={<LeftOutline />}
        onBack={onGoBack}
      />
      <CheckList value={[langOpt.key]} onChange={onSelectLang}>
        {!!langOptions.length &&
          langOptions.map((item) => (
            <CheckList.Item value={item.key} key={item.key}>
              {item.text}
            </CheckList.Item>
          ))}
      </CheckList>
    </div>
  )
}

export default LangSetting
